interface inputtaxdetails  {
    item?: string,
    align: string,
    col?: string,
    quantity?: string,
    amount?: string,
    tax?: string,
    indent?: number | string,
    isHead?: boolean,
    row?: string,
    colspan3?: number,
    justCol3?: boolean,
    canEdit?: boolean
}

let list = [
    {
        title: "一、申报抵扣的进项税额",
        colspan: "5",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        item: "项目",
        align: "center",
        col: "栏次",
        quantity: "份数",
        amount: "金额",
        tax: "税额",
        indent: 0,
        isHead: true
    },
    {
        item: "（一）认证相符的增值税专用发票",
        align: "left",
        col: "1=2+3",
        row: "1",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        item: "其中：本期认证相符且本期申报抵扣",
        align: "left",
        col: "2",
        row: "2",
        quantity: "",
        amount: "",
        tax: "",
        indent: 39,
        canEdit: true
    },
    {
        item: "前期认证相符且本期申报抵扣",
        align: "left",
        col: "3",
        row: "3",
        quantity: "",
        amount: "",
        tax: "",
        indent: 78
    },
    {
        item: "（二）其他扣税凭证",
        align: "left",
        col: "4=5+6+7+8a+8b",
        row: "4",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        item: "其中：海关进口增值税专用缴款书",
        align: "left",
        col: "5",
        row: "5",
        quantity: "",
        amount: "",
        tax: "",
        indent: 39,
        canEdit: true
    },
    {
        item: "农产品收购发票或者销售发票",
        align: "left",
        col: "6",
        row: "6",
        quantity: "",
        amount: "",
        tax: "",
        indent: 78,
        canEdit: true
    },
    {
        item: "代扣代缴税收通用缴款书",
        align: "left",
        col: "7",
        row: "7",
        quantity: "",
        amount: "",
        tax: "",
        indent: 78,
        canEdit: true
    },
    {
        item: "加计扣除农产品进项税额",
        align: "left",
        col: "8a",
        row: "8a",
        quantity: "",
        amount: "",
        tax: "",
        indent: 78,
        canEdit: true
    },
    // 加计扣除农产品进项税额
    {
        item: "其他",
        align: "left",
        col: "8b",
        row: "8b",
        quantity: "",
        amount: "",
        tax: "",
        indent: 78,
        canEdit: true
    },
    {
        item: "（三）本期用于购建不动产的扣税凭证",
        align: "left",
        col: "9",
        row: "9",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        item: "（四）本期用于抵扣的旅客运输服务扣税凭证",
        align: "left",
        col: "10",
        row: "10",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        item: "（五）外贸企业进项税额抵扣证明",
        align: "left",
        col: "11",
        row: "11",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        item: "当期申报抵扣进项税额合计",
        align: "left",
        col: "12=1+4+11",
        row: "12",
        quantity: "",
        amount: "",
        tax: "",
        indent: 0
    },
    {
        title: "二、进项税额转出额",
        colspan: "5",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        item: "项目",
        align: "center",
        col: "栏次",
        tax: "税额",
        colspan3: 3,
        justCol3: true,
        indent: 0,
        isHead: true
    },
    {
        item: "本期进项税额转出额",
        align: "left",
        col: "13=14至23之和",
        row: "13",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 0
    },
    {
        item: "其中：免税项目用",
        align: "left",
        col: "14",
        row: "14",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 0,
        canEdit: true
    },
    {
        item: "集体福利、个人消费",
        align: "left",
        col: "15",
        row: "15",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "非正常损失",
        align: "left",
        col: "16",
        row: "16",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "简易计税方法征税项目用",
        align: "left",
        col: "17",
        row: "17",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "免抵退税办法不得抵扣的进项税额",
        align: "left",
        col: "18",
        row: "18",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: " 纳税检查调减进项税额",
        align: "left",
        col: "19",
        row: "19",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "红字专用发票信息表注明的进项税额",
        align: "left",
        col: "20",
        row: "20",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "上期留抵税额抵减欠税",
        align: "left",
        col: "21",
        row: "21",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "上期留抵税额退税",
        align: "left",
        col: "22",
        row: "22",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        item: "其他应作进项税额转出的情形",
        align: "left",
        col: "23",
        row: "23",
        quantity: "",
        amount: "",
        tax: "",
        colspan3: 3,
        justCol3: true,
        indent: 39,
        canEdit: true
    },
    {
        title: "三、待抵扣进项税额",
        colspan: "5",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        item: "项目",
        align: "center",
        col: "栏次",
        quantity: "份数",
        amount: "金额",
        tax: "税额",
        indent: 0,
        isHead: true
    },
    {
        item: "（一）认证相符的增值税专用发票",
        align: "left",
        col: "24",
        row: "24",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    },
    {
        item: "期初已认证相符但未申报抵扣",
        align: "left",
        col: "25",
        row: "25",
        quantity: "",
        amount: "",
        tax: "",
        indent: "39"
    },
    {
        item: "本期认证相符且本期未申报抵扣",
        align: "left",
        col: "26",
        row: "26",
        quantity: "",
        amount: "",
        tax: "",
        indent: "39"
    },
    {
        item: "期末已认证相符但未申报抵扣",
        align: "left",
        col: "27",
        row: "27",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    },
    {
        item: "其中：按照税法规定不允许抵扣",
        align: "left",
        col: "28",
        row: "28",
        quantity: "",
        amount: "",
        tax: "",
        indent: "50"
    },
    {
        item: "（二）其他扣税凭证",
        align: "left",
        col: "29=30至33之和",
        row: "29",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    },
    {
        item: "其中：海关进口增值税专用缴款书",
        align: "left",
        col: "30",
        row: "30",
        quantity: "",
        amount: "",
        tax: "",
        indent: "39"
    },
    {
        item: "农产品收购发票或者销售发票",
        align: "left",
        col: "31",
        row: "31",
        quantity: "",
        amount: "",
        tax: "",
        indent: "78"
    },
    {
        item: "代扣代缴税收缴款凭证",
        align: "left",
        col: "32",
        row: "32",
        quantity: "",
        amount: "",
        tax: "",
        indent: "78"
    },
    {
        item: "其他",
        align: "left",
        col: "33",
        row: "33",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    },
    {
        item: "",
        align: "left",
        col: "34",
        row: "34",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    },
    {
        title: "四、其他",
        colspan: "5",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        item: "项目",
        align: "center",
        col: "栏次",
        quantity: "份数",
        amount: "金额",
        tax: "税额",
        indent: 0,
        isHead: true
    },
    {
        item: "本期认证相符的增值税专用发票",
        align: "left",
        col: "35",
        row: "35",
        quantity: "",
        amount: "",
        tax: "",
        indent: "",
        canEdit: true
    },
    {
        item: "代扣代缴税额",
        align: "left",
        col: "36",
        row: "36",
        quantity: "",
        amount: "",
        tax: "",
        indent: ""
    }
]


let inputtaxdetails = {
    list: list,
}
export default inputtaxdetails
